import React from 'react';
import PropTypes from 'prop-types';
import {setIntendedUrl} from "../modules/auth-persistor";
import {useAuth} from "../context/auth";
import {Navigate, useLocation} from "react-router-dom";
import {AppRoutes} from "../utils/constants";
import BaseComponent from "./base-component";

function AuthRoute ({ component: Component, title, ...rest }) {
  let {authenticated} = useAuth();
  const location = useLocation();

  if (!authenticated) {
    setIntendedUrl(location.pathname);
  }

  // Use the layout defined at the page level, if available
  const getLayout = Component.getLayout || ((page) => page);
  const appWithLayout = getLayout(<Component {...rest} />);

  const BaseComponentWrappedApp = (
      <BaseComponent component={() => appWithLayout} />
  );

  return (
      authenticated ? BaseComponentWrappedApp
          : <Navigate to={AppRoutes.login.path} replace state={{from: location}} />
  )
}

AuthRoute.displayName = 'Auth Route';

AuthRoute.propTypes = {
  component: PropTypes.func.isRequired,
  rest: PropTypes.object,
  location: PropTypes.object,
  title: PropTypes.string
};

export default AuthRoute;
